import createReactClass from 'create-react-class';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';

export default function ComponentFactory (classDef, mapStateToProps = state => state, actions = {}) {
    const comp = createReactClass(classDef);
    return (connect(mapStateToProps, (dispatch) => {
        return _.reduce(actions, (result, action, actionName) => {
            result[actionName] = bindActionCreators(action, dispatch);
            return result;
        }, {});
    })(comp));
}